export interface ScreenshotEntry {
    /** Filename inside `public/assets/screenshots/` (and, if present, `public/assets/screenshots/dark/`). */
    filename: string;
    /** Short caption shown under the screenshot in the strip. */
    caption: string;
    /** Accessible alt text. */
    alt: string;
}

// The first entry is the hero image; the rest fill the "See it in action"
// strip, which is hidden while there are none. Dark-mode variants in
// `dark/` are optional — Screenshot falls back to the light file.
export const screenshots: ScreenshotEntry[] = [
    {
        filename: "home.png",
        caption: "Your drawings and the community gallery",
        alt: "Magic Crayons home screen showing your coloring pages, community drawings, and the box to describe a new one",
    },
];
